import React, { useEffect, useState } from 'react';
import { Button } from 'reactstrap';
import { useDispatch } from 'react-redux';
import {
  setScreenType,
  useCallId,
  useCallNumber,
  useCallType,
  useScreenType
} from '../../../store/slices/dialSlice';
import * as Icon from 'react-feather';
import PropTypes from 'prop-types';
import {
  attendedTransfer,
  blindTransfer,
  transferUserOptionGet
} from '../../../store/slices/callingSlice';
import { useUserDetails } from '../../../store/slices/authSlice';
import FormSelect from '../../form/FormSelect';
import { convertToMask } from '../../../utils/common';
import { useTranslation } from 'react-i18next';

const UserTransferScreen = ({ number }) => {
  const callNumber = useCallNumber();
  const user = useUserDetails();
  const callId = useCallId();
  const callType = useCallType();
  const screenType = useScreenType();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [userOptions, setUserOptions] = useState([]);
  const [userId, setUserId] = useState('');

  const fetchUserOptions = async () => {
    try {
      const response = await dispatch(transferUserOptionGet()).unwrap();
      if (response && response.success) {
        const options = response?.data.map((item) => ({
          label: item.Username,
          value: item.id
        }));
        setUserOptions(options || []);
      } else {
        setUserOptions([]);
      }
    } catch (error) {
      setUserOptions([]);
      console.error('Error fetching user options:', error);
    }
  };

  useEffect(() => {
    fetchUserOptions();
  }, []);

  const onSelectUser = async () => {
    try {
      const payload = {
        uuid: callId,
        selected_user_id: userId,
        calltype: callType
      };
      let response;
      if (screenType === 'BLIND_TRANSFER') {
        response = await dispatch(blindTransfer(payload)).unwrap();
      } else {
        response = await dispatch(attendedTransfer(payload)).unwrap();
        dispatch(setScreenType('TRANSFER_HANGUP'));
      }
      console.log('response', response);
    } catch (error) {
      console.log('error', error);
    }
  };

  useEffect(() => {
    if (userId) {
      onSelectUser();
    }
  }, [userId]);

  return (
    <div className="h-100 call-action-btn-container">
      <div className="mt-auto mb-5 text-white text-center fw-bold fs-4">
        {user?.process_details?.numberMasking === 'true'
          ? convertToMask(callNumber || number)
          : callNumber || number}
      </div>
      <div className="text-white mb-auto">
        <FormSelect
          isShowLabel={false}
          name="userId"
          label={t('user')}
          placeholder="Select User"
          value={userId}
          options={userOptions}
          onChange={(e) => {
            setUserId(e?.target?.value);
          }}
        />
      </div>
      <div className="call-button-wrapper mt-auto pb-4">
        <Button
          className="back-button"
          onClick={() => {
            dispatch(setScreenType('TRANSFER'));
          }}>
          <Icon.ArrowLeft className="back-icon text-primary" />
        </Button>
      </div>
    </div>
  );
};

UserTransferScreen.propTypes = {
  number: PropTypes.string
};

export default UserTransferScreen;
